import { PATHS } from '../../AppConstants';
import {
	ASSET_PATH
} from '../../../assetsPath';
export const expSeoImgPath = ASSET_PATH.IMAGES + 'seo/expense/';

export const pageData = {
	titleTxt: 'Travel & Expense Management Online Tool For Corporates - myBiz By MakeMyTrip',
	description: 'myBiz By MakeMytrip Expense Management tool captures all expenses made for official purposes, including business travel, directly on a single platform. Our easy-to-use tool is free of cost and will ensure that you can effortlessly reconcile and reimburse all expenditures made by your employees.'
};

export const bannerCarouselData = [{
	carouselMainHead: 'Reduce Leakage in Official Expenses',
	heading: 'myBiz Expenses',
	subHeading: 'Use the same platform to record both travel and other miscellaneous expenses incurred during an official trip.',
	carouselUrl: {
		type: 'img',
		url: expSeoImgPath + 'car-categories.png',
		mobileUrl: expSeoImgPath + 'car-categories.png'
	}
},
{
	carouselMainHead: 'Setup Policies',
	heading: 'myBiz Expenses',
	subHeading: 'Category-wise policy integration for granular control and better compliance.',
	carouselUrl: {
		type: 'img',
		url: expSeoImgPath + 'car-policies.png',
		mobileUrl: expSeoImgPath + 'car-policies.png'
	}
},
{
	carouselMainHead: 'Real-time Reports',
	heading: 'myBiz Expenses',
	subHeading: 'Keep track of all expenses on a single platform. Also access reports and T&E Forms for easy reconciliation and auditing purpose.',
	carouselUrl: {
		type: 'img',
		url: expSeoImgPath + 'car-reports.png',
		mobileUrl: expSeoImgPath + 'car-reports.png'
	}
},
{
	carouselMainHead: 'Regulate Expense Approvals',
	heading: 'myBiz Expenses',
	subHeading: `Define an easy-to-seek approval workflow basis your company's policy. Set conditional approvals as per each category's budget limit.`,
	carouselUrl: {
		type: 'img',
		url: expSeoImgPath + 'car-approvals.png',
		mobileUrl: expSeoImgPath + 'car-approvals.png'
	}
}
];

export const NavigationLinks = [
	{
		text: 'Benefits',
		type: 'ben',
		link: 'Benefits',
		trackVal: 'benefits_clicked',
		pageurl: PATHS.EXPENSE_SEO
	},
	{
		text: 'Features',
		type: 'case',
		link: 'Features',
		trackVal: 'features_clicked',
		pageurl: PATHS.EXPENSE_SEO
	}
];

export const DescriptionTxt = {
	heading: '<span class="orgtxt">One Stop</span> solution for all your Official Expenses',
	desc: 'With our Expense Management tool, capture all expenses made for official purposes, including business travel, directly on a single platform. Our easy-to-use tool will ensure that you can effortlessly reconcile and reimburse all expenditures made by your employees '
};

export const WhyTxt = {
	heading: 'Why use myBiz Expenses?',
	benefits: [{
		icon: 'save',
		heading: 'Save Expenses',
		desc: 'Corporate expense management automation helps in reducing leakage in travel expense.'
	},
	{
		icon: 'seamless',
		heading: 'Seamless Process',
		desc: 'Same platform is used to record the entire travel expenses as well as other spends, making the process seamless.'
	}/* ,
	{
		icon: 'freecost',
		heading: 'Free of Cost',
		desc: 'It is completely free of cost unlike other expense management tools in the market.'
	} */
	]
};

export const benefitsData = {
	heading: 'How does myBiz help you Manage Expenses?',
	features: [{
		icon: 'manage',
		heading: 'Admin / HR',
		list: ['Category-wise policy integration for granular control.',
			'T&E form download with attached receipts.',
			'Configurable policies with an easy-to-seek approval process for better compliance.'
		]
	},
	{
		icon: 'finance',
		heading: 'Finance Team',
		list: ['Single tool for expense management & travel solutions.',
			'End-to-end visibility on your travel & other expenses.',
			'Real-time availability of expense claims reports for easy record maintenance and auditing purposes.'
		]
	},
	{
		icon: 'employees',
		heading: 'Employees',
		list: ['An online expense manager ensures effortless filing of official expenses.',
			'Full process visibility on expense claim status.',
			'All travel-related expenses are picked by our integrated travel & expense management solution.']
	}
	]
};

export const featuresData = {
	tabs: [{
		label: 'Policies',
		key: 'POL'
	},
	{
		label: 'Reports',
		key: 'REP'
	},
	{
		label: 'T&E Forms',
		key: 'TNE'
	}],
	data: {
		POL: {
			imgSrc: expSeoImgPath + 'policy.png',
			heading: 'Setup your <span class="orgtxt">Policies</span>',
			desc: 'Single tool for Expense management & travel. End to end visibility in your travel & other expenses.'
		},
		REP: {
			imgSrc: expSeoImgPath + 'report.png',
			heading: 'Manage all your <span class="orgtxt">Reports</span>',
			desc: 'Download .csv expense reports for your reconciliation needs.'
		},
		TNE: {
			imgSrc: expSeoImgPath + 'tne.png',
			heading: '<span class="orgtxt">T&E Form</span> Settings',
			desc: 'Create an alphanumeric code that will be unique to each expense request raised by an employee.'
		}
	}
};

export const faqData = {
	heading: 'Frequently Asked Questions',
	faqList: [{
		index: 1,
		title: 'What is expense management?',
		desc: 'Expense management is a reporting solution which captures business expenses and helps have a comprehensive view on it through a robust reporting mechanism. It helps organisations to manage end-to-end expense workflow.'
	},
	{
		index: 2,
		title: 'How does expense management help corporates streamline their finances?',
		desc: 'An expense management software empowers the finance team with easy workflows for faster processing and provides a single view of all expenses to track budgets (and keep them in check).'
	},
	{
		index: 3,
		title: 'How to configure expense management?',
		desc: 'Setting up expense management is a 3 step process:',
		list: ['Define Categories as per your organisation’s needs.', 'Set policies for employees.', 'Configure approval process.']
	},
	{
		index: 4,
		title: 'How is payment made to the employees?',
		desc: 'We provide you with an excel report which you can use in your HRMS tools to reimburse, thus, streamlining employee expense management system right from the start.'
	},
	{
		index: 5,
		title: 'How is approval handled in corporate expense management?',
		desc: 'myBiz expense management software provides flexibility in configuring approval workflow depending upon the Category, Budget and Policy defined.'
	},
	{
		index: 6,
		title: 'What categories are supported in our travel and expense management?',
		desc: 'myBiz travel and expense management system/platform allows the company to configure categories as per their own needs. Expense related to official travel, team engagement activities, relocation, phone bills and any other spends made in the official capacity can be recorded.'
	}]
};
